import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import EmailTypeForm from '../../../components/forms/EmailTypeForm';
import { useEmailTypeApi } from '../../../hooks/useEmailTypeApi';
import { useNavigate, useParams } from 'react-router-dom';
import { EmailTypeDTO } from '../../../services/apiClient';

const EmailTypeEdit: React.FC = () => {
  const { getById, edit } = useEmailTypeApi();
  const [entityData, setEntityData] = useState<EmailTypeDTO | null>(null);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Email Types', href: '/admin/emailtypes' },
    { label: 'Edit', href: '#' },
  ];

  useEffect(() => {
    const fetchEntityData = async () => {
      try {
        const response = await getById(id!);
        setEntityData(response?.data || null);
      } catch (error) {
        console.error('Error fetching EmailType data:', error);
      }
    };

    fetchEntityData();
  }, [id]);

  const handleSubmit = async (data: any) => {
    try {
      setIsSubmitting(true);
      await edit(id!, data);
      navigate('/admin/emailtypes');
    } catch (error) {
      console.error('Error updating EmailType:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/emailtypes"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission="Settings.EmailType.Edit"
    >
      {entityData ? (
        <EmailTypeForm
          initialValues={entityData}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/emailtypes')}
          isLoading={isSubmitting}
        />
      ) : (
        <p>Loading...</p>
      )}
    </AdminLayout>
  );
};

export default EmailTypeEdit;
